import { useGetList, type RaRecord } from "ra-core";
import { useMemo } from "react";

/**
 * Distinct non-empty values of `field` across `resource`, sorted, as
 * `{ id, name }` choices. Merged with `baseValues` so fixed options stay first.
 */
export const useDistinctValues = (
  resource: string,
  field: string,
  baseValues: readonly string[] = [],
) => {
  const { data } = useGetList<RaRecord>(resource, {
    pagination: { page: 1, perPage: 1000 },
    sort: { field, order: "ASC" },
  });

  return useMemo(() => {
    const found = (data ?? [])
      .map((record) => record[field])
      .filter((v): v is string => typeof v === "string" && v.trim() !== "");
    const values = [...new Set([...baseValues, ...found.sort()])];
    return values.map((value) => ({ id: value, name: value }));
  }, [data, field, baseValues]);
};
